import { render, staticRenderFns } from "./DashboardValueCard.vue?vue&type=template&id=2f1f4794&scoped=true"
import script from "./DashboardValueCard.vue?vue&type=script&lang=js"
export * from "./DashboardValueCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1f4794",
  null
  
)

export default component.exports